import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import { PREFIX_SPROMOTION_API } from '@/service'

const api = {
  groupList: PREFIX_SPROMOTION_API + 'group/getGroupList.do'
}

export default {
  // 获取参团列表
  async fetchGroupList({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.groupList}?${query}`)
      const json = await res.json()
      if (json && json.data) {
        const groups = json.data.infoList || []
        commit('setGroupList', { groups })
        return groups
      }
    } catch (e) {
      console.log(e)
    }
  },
  async fetchNewGroupList({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.groupList}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  }
}
